module.exports = __webpack_public_path__ + "static/lean-thinking-cc9fc81e3e0b8c6e1ac71995d74298c6.jpg";